import React from "react";

function Home() {
    return <h1 className="font-body xs:text-lg sm:text-xl md:text-2xl lg:text-2xl text-white font-thin">My name is Philip and I study Computer Science at the University of Waterloo.</h1>;
}

export default Home;
